import { useShowContext } from 'framework/show';
import { useMessageService, ErrorMessage, SuccessMessage } from 'framework/ui/Message';
import { StaffingDataType } from 'domain/shared/staffing';
import useStaffingRiskService from '../../services/staffingRiskService';

export const useFollowUpsManagement = (refetch?: () => Promise<void>) => {
  const { data, setData } = useShowContext<StaffingDataType>();
  const { updateFollowUp, deleteFollowUp } = useStaffingRiskService();
  const { addMessage } = useMessageService();

  const projectData = data.getData();

  const handleFollowUpRemove = async (itemId: string | number, followUpId: string | number) => {
    try {
      await deleteFollowUp(projectData.staffingRisk!.id!, followUpId as string);
      const updatedFollowUps = projectData.staffingRisk?.followUps?.filter(f => f.id !== followUpId);
      setData!({
        ...projectData,
        staffingRisk: { ...projectData.staffingRisk, followUps: updatedFollowUps },
      });
      addMessage(new SuccessMessage('Follow-up deleted successfully'));
      await refetch?.();
    } catch (error) {
      addMessage(new ErrorMessage('Failed to delete follow-up'));
    }
  };

  const handleFollowUpUpdate = async (
    itemId: string | number,
    followUpId: string | number,
    updateData: { description: string; date: string },
  ) => {
    try {
      const response = await updateFollowUp(projectData.staffingRisk!.id!, followUpId as string, {
        id: followUpId,
        staffingRiskId: projectData.staffingRisk!.id!,
        description: updateData.description,
        followUpDate: updateData.date,
      });
      const updatedFollowUps = projectData.staffingRisk?.followUps
        ?.filter(item => item.id !== followUpId)
        .concat(response)
        .sort((a, b) => new Date(a.followUpDate!).getTime() - new Date(b.followUpDate!).getTime());
      setData!({
        ...projectData,
        staffingRisk: { ...projectData.staffingRisk, followUps: updatedFollowUps },
      });
      addMessage(new SuccessMessage('Follow-up updated successfully'));
      await refetch?.();
    } catch (error) {
      addMessage(new ErrorMessage('Failed to update follow-up'));
    }
  };

  return {
    handleFollowUpRemove,
    handleFollowUpUpdate,
  };
};
